import { AlarmTypeGroup } from '@hakimo-ui/hakimo/types';
import {
  useCanDeleteAlarmTypeGroup,
  useCanUpdateAlarmTypeGroup,
} from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { TrashIcon } from '@heroicons/react/24/outline';
import { PencilSquareIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import AddEditAlarmTypeGroup from '../add-alarm-type-group/AddEditAlarmTypeGroup';
import DeleteAlarmTypeGroup from './DeleteAlarmTypeGroup';

interface Props {
  alarmTypeGroup: AlarmTypeGroup;
}

export function ActionsAlarmTypeGroup(props: Props) {
  const { alarmTypeGroup } = props;
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const canUpdate = useCanUpdateAlarmTypeGroup();
  const canDelete = useCanDeleteAlarmTypeGroup();

  return (
    <div className="flex flex-row gap-4">
      {canUpdate && (
        <Button
          variant="icon"
          onClick={() => {
            setOpenEditModal(true);
          }}
        >
          <PencilSquareIcon className="mr-1 h-5 w-5" />
          Edit Alarm Type Group
        </Button>
      )}
      {openEditModal && (
        <AddEditAlarmTypeGroup
          alarmTypeGroup={alarmTypeGroup}
          onClose={() => setOpenEditModal(false)}
        />
      )}
      {canDelete && (
        <Button variant="icon" onClick={() => setOpenDeleteModal(true)}>
          <TrashIcon className="mr-1 h-5 w-5" />
        </Button>
      )}
      {openDeleteModal && (
        <DeleteAlarmTypeGroup
          alarmTypeGroup={alarmTypeGroup}
          onClose={() => setOpenDeleteModal(false)}
        />
      )}
    </div>
  );
}

export default ActionsAlarmTypeGroup;
